<template>
  <b-button-group :size="size" class="d-flex" :style="groupStyles">
    <b-button
      v-for="region in regions"
      :key="region"
      :id="region"
      :variant="isRegionSelected(region) ? 'primary' : ''"
      @click="regionClicked(region)"
      :disabled="disabled"
    >
      {{ region }}
    </b-button>
  </b-button-group>
</template>

<script>
export default {
  name: 'RegionFilterButtonGroup',
  props: {
    regions: {
      type: Array,
      required: true,
      validator: value => value.length > 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'sm',
    },
    width: {
      type: [String, Number],
      default: '100px',
    },
    gap: {
      type: [String, Number],
      default: '2px',
    },
    buttonWidth: {
      type: [String, Number],
      default: '33px',
    },
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    groupStyles() {
      return {
        width: typeof this.width === 'number' ? `${this.width}px` : this.width,
        gap: typeof this.gap === 'number' ? `${this.gap}px` : this.gap,
      };
    },
  },
  methods: {
    // für die variant
    isRegionSelected(region) {
      // hier wird "value" benutzt, da es aus dem prop des v-models kommt
      return this.value.includes(region);
    },

    regionClicked(region) {
      // leeres array damit die ausgewählten regions gespeichert werden
      let newSelectedRegions = [];

      // wird zb für zvc benötigt, damit man direkt zwischen den beiden regions switchen kann
      if (this.regions.length === 2) {
        // Wenn die geklickte Region bereits ausgewählt ist, wird die Auswahl geleert.
        if (this.isRegionSelected(region)) {
          newSelectedRegions = [];
        } else {
          // sonst wird die region hinzugefügt
          newSelectedRegions = [region];
        }
        // wenn es mehr als 2 Regions gibt
      } else {
        if (this.isRegionSelected(region)) {
          // Entferne die Region aus der Auswahl
          newSelectedRegions = this.value.filter(reg => reg !== region);
        } else {
          // Wenn bereits die maximale Anzahl an Regionen ausgewählt ist
          if (this.value.length >= this.regions.length - 1) {
            // Setze die Auswahl zurück
            newSelectedRegions = [];
          } else {
            // Füge die Region zur bestehenden Auswahl hinzu
            newSelectedRegions = [...this.value, region];
          }
        }
      }
      console.log('newSelectedRegions: ', newSelectedRegions);
      this.$emit('input', newSelectedRegions);
    },
  },
};
</script>
